// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/ui/components/LiveBadge.module.css';
import {Tooltip, type TooltipPosition} from '@app/features/ui/tooltip/Tooltip';
import {useLingui} from '@lingui/react/macro';
import {clsx} from 'clsx';

interface LiveBadgeProps {
	className?: string;
	showTooltip?: boolean;
	tooltipPosition?: TooltipPosition;
}
export function LiveBadge({className, showTooltip = true, tooltipPosition}: LiveBadgeProps) {
	const {t} = useLingui();
	const badge = <span className={clsx(styles.liveBadge, className)}>{t`Live`}</span>;
	if (showTooltip) {
		return (
			<Tooltip text={t`Screen Sharing`} position={tooltipPosition}>
				{badge}
			</Tooltip>
		);
	}
	return badge;
}
